export default __webpack_public_path__ + "static/media/TokiRGB_cyan.fbfbe262.png";